export default __webpack_public_path__ + "d8327d4d59441f809b3a0f0e22a22e76.svg";